export enum LoginType {
  Register = 'register',
  Login = 'login',
  AuthenticationToken = 'authentication-token'
}
